import React, { useEffect, useState } from "react";
import "./MessageA13rechargeOptions.css";

const MessageA13rechargeOptions = (props) => {
  const [selected, setSelected] = useState(null);
  const [hovered, setHovered] = useState(null);
  const data = JSON.parse(props?.item?.text);

  const handleSelect = (index , value) => {
    setSelected(index);
    props?.setErrors((prevErrors) => ({
      ...prevErrors,
      [props?.index]: {
        key1: value,
        displayName: value,
      },
    }));

  };

  useEffect(()=>{
//  props?.showMaximumChat(true)
  },[])

  return (
    <div className="recharge-container">
      {/* <h3 className="title">
        Please find the transactions available using the selected payment mode
      </h3> */}
      {data?.transOptions.map((item, index) => (
        <div
          key={index}
          className={`transaction-card ${selected === index ? "selected" : ""} action-tab`}
          onClick={() => data?.isRadioButton && handleSelect(index,item?.transId)}
          onMouseEnter={() => setHovered(index)}
          onMouseLeave={() => setHovered(null)}
        >
          {data.isRadioButton && (
            <input
              type="radio"
              name="transaction"
              className="radio-btn"
              checked={selected === index}
              readOnly
            />
          )}
          <div className="transaction-content">
            <div className="transaction-header">{item?.rechargeType}</div>
            <div className="transaction-desc ">{item?.description}</div>
            <div className="transaction-footer">
              <span className="amount A3f">₹{item?.amount}/-</span>
              <span className="time A3f">{item?.transTime}</span>
            </div>
            <div
              className={`status`}
            >
              Recharge Status :{item?.rechargeStatus}
            </div>
          </div>

          {/* Hover modal UI */}
          {/* {hovered === index && (
            <div className="hover-modal">
              <p><strong>Transaction Details:</strong></p>
              <p>{item.description}</p>
              <p>Amount: ₹{item.amount}</p>
              <p>Status: {item.rechargeStatus}</p>
              <p>Time: {item.transTime}</p>
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
};

export default MessageA13rechargeOptions;
